import React from 'react';
import { uid } from '../_utils';
var ButtonSkeleton = function (props) {
    var id = props.id, onClick = props.onClick, children = props.children, customClass = props.customClass, className = props.className, disabled = props.disabled;
    return (React.createElement("button", { id: id ? id : uid('button'), className: "btn " + (customClass != null
            ? customClass
            : 'skeleton-line skeleton-h-xl skeleton-w-lg') + (className ? " " + className : ''), disabled: disabled, onClick: onClick }, children ? children : React.createElement("span", null, "\u00A0")));
};
export default React.memo(ButtonSkeleton);
